import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface OpportunityTypeState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allOpportunityType: [] | null | any;
}

const initialState: OpportunityTypeState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allOpportunityType: null,
};

export const opportunityTypeSlice = createSlice({
  name: 'OpportunityType',
  initialState,
  reducers: {
    setAllOpportunityType: (state, action) => {
      state.allOpportunityType = action.payload.data;
    },
    setOpportunityType: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllOpportunityTypeBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: () => initialState,
  },
});

export const {
  setAllOpportunityType,
  setOpportunityType,
  setAllOpportunityTypeBySearch,
  reset,
} = opportunityTypeSlice.actions;

// Selectors
export const allOpportunityTypeDetails = (state: RootState) =>
  state.opportunityType.allOpportunityType;

export const getOpportunityTypeDetails = (state: RootState) =>
  state.opportunityType.data;

export const getOpportunityTypeTotalRecords = (state: RootState) =>
  state.opportunityType.totalRecords;

export const getAllOpportunityTypeBySearch = (state: RootState) =>
  state.opportunityType.data;

export default opportunityTypeSlice.reducer;
